<template>
  <b-container fluid>
    <b-card no-body>
      <b-overlay
        :show="isLoading"
        rounded="sm"
      >
        <div class="m-2">
          <b-form>
            <b-row>
              <b-col
                sm="12"
                md="6"
                lg="6"
                xl="6"
              >
                <b-form-group
                  label="Năm học"
                  label-for="yearId"
                >
                  <v-select
                    id="yearId"
                    v-model="yearId"
                    label="name"
                    :options="years"
                    :reduce="option => option.id"
                    :clearable="false"
                  />
                </b-form-group>
              </b-col>
              <b-col
                sm="12"
                md="6"
                lg="6"
                xl="6"
              >
                <b-form-group
                  label="Học kỳ"
                  label-for="semesterId"
                >
                  <v-select
                    id="semesterId"
                    v-model="semesterId"
                    :options="semesters"
                    :clearable="false"
                    :reduce="option => option.value"
                  />
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <div class="w-100 d-flex justify-content-center">
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-primary"
                    class="mr-1"
                    @click="exportExcelSummary"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="DownloadIcon" /> Xuất excel tổng hợp kết quả học tập
                    </span>
                  </b-button>

                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="outline-primary"
                    @click="exportFileStatistic"
                  >
                    <span class="text-nowrap text-right">
                      <feather-icon icon="DownloadIcon" /> Xuất excel thống kê kết quả học tập
                    </span>
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </b-form>
        </div>
      </b-overlay>
    </b-card>
  </b-container>
</template>

<script>
import {
  BButton,
  BCard,
  BCol,
  BContainer,
  BForm,
  BFormGroup,
  BOverlay,
  BRow,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import { getUser } from '@/auth/utils'
import Ripple from 'vue-ripple-directive'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import * as XLSX from 'xlsx'
import api from './api'

export default {
  name: 'SemesterExam',
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    BContainer,
    BFormGroup,
    BCol,
    BRow,
    BForm,
    BButton,
    BCard,
    BOverlay,
  },
  data() {
    return {
      user: getUser(),
      isLoading: false,
      yearId: null,
      semesterId: null,
      years: [],
      semesters: [],
    }
  },
  computed: {
    currentYear() {
      return new Date().getFullYear()
    },
  },
  async created() {
    await this.begin()
  },
  methods: {
    async begin() {
      this.isLoading = true
      try {
        this.years = await api.getYears()
        this.semesters = [
          { value: 1, label: 'Học kỳ 1' },
          { value: 2, label: 'Học kỳ 2' },
          { value: 3, label: 'Học kỳ hè' },
        ]
        if (this.years.length > 0) {
          const found = this.years.find(year => year.endYear === this.currentYear)
          this.yearId = found ? found.id : this.years[0].id
        }
      } catch (e) {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: `[${e.code}] ${e.message}`,
            icon: 'XCircleIcon',
            variant: 'danger',
          },
        })
      } finally {
        this.isLoading = false
      }
    },
    async exportExcelSummary() {
      const data = await api.downloadSummaryLearningBySemesterAndYear({
        yearId: this.yearId,
        semesterId: this.semesterId,
      })
      const a = document.createElement('a')
      document.body.appendChild(a)
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = 'danh-sach-tong-hop-ket-qua-hoc-tap'
      a.click()
      window.URL.revokeObjectURL(url)
    },
    async exportFileStatistic() {
      const data = await api.downloadStatisticLearningBySemesterAndYear({
        yearId: this.yearId,
        semesterId: this.semesterId,
      })
      const a = document.createElement('a')
      document.body.appendChild(a)
      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const url = window.URL.createObjectURL(blob)
      a.href = url
      a.download = 'thong-ke-ket-qua-hoc-tap'
      a.click()
      window.URL.revokeObjectURL(url)
    },
  },
}
</script>
